import { GlobalServiceService } from 'src/app/services/global-service.service';
import { LocalstorageService } from './../services/localstorage.service';
import { Injectable } from '@angular/core';
import { ApiBasic } from '../services/api-basic';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {
  appBase: any;
  private token = ""
  subscription: Subscription;
  constructor(
    public http: HttpClient,
    public api: ApiBasic,
    public _global: GlobalServiceService,
    private _localstorage: LocalstorageService,
  ) {
    // this._global.base_url = this.api.base_url
    this.token = _global.token
    this.subscription = this._localstorage.getToken().subscribe(message => {
      this.token = _global.token
    });
  }

  public getLocations(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/locations?user_id=" + data.user_id + "&client_id=" + data.client_id, httpOptions)
  }
  public postLocations(user_id, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.post(this._global.base_url + "/locations?user_id=" + user_id, data, httpOptions)
  }
  public getStates() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.get(this._global.base_url + "/filters/states/all", httpOptions)
  }
  public patchLocations(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    return this.http.patch(this._global.base_url + "/locations?user_id=" + data.user_id, data, httpOptions)
  }
  public deleteLocations(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.token}`
      })
    };
    this.api.stringfyObject(data)
    return this.http.delete(this._global.base_url + "/locations?" + this.api.stringfyObject(data), httpOptions)
  }



}
